import { useState, useEffect } from "react";

export function ElapsedTimer({ testid, className = "font-mono text-sm font-bold tabular-nums text-[#00e5ff]" }) {
  const [secs, setSecs] = useState(0);
  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => setSecs(Math.floor((Date.now() - start) / 1000)), 1000);
    return () => clearInterval(id);
  }, []);
  const mm = String(Math.floor(secs / 60)).padStart(2, "0");
  const ss = String(secs % 60).padStart(2, "0");
  return (
    <span data-testid={testid} className={className}>
      {mm}:{ss}
    </span>
  );
}
